import FooterLogo from "@/assets/images/footer_img.png";

const Footer = () => {
  return (
    <footer className="flex h-auto flex-col items-center justify-center gap-4 border-t border-gray-light bg-white px-4 py-8 sm:px-6 md:px-8">
      <img src={FooterLogo} className="h-8 object-contain opacity-60" />
      <div className="flex flex-col gap-0.5 text-center text-[11px] font-light text-gray-dull">
        <p>경기도 평택시 신흥 1로 2길 61, 2층 | TEL. 031-651-9680</p>
        <p>문의사항: <a href="mailto:peration0422@gmail.com" className="text-primary hover:underline">peration0422@gmail.com</a></p>
        <p>2024ⓒ 평택 온누리 개발팀 All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
